import { render, staticRenderFns } from "./AssessmentSummaryBlock.vue?vue&type=template&id=b0c29f32&scoped=true&"
import script from "./AssessmentSummaryBlock.vue?vue&type=script&lang=ts&"
export * from "./AssessmentSummaryBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentSummaryBlock.vue?vue&type=style&index=0&id=b0c29f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c29f32",
  null
  
)

export default component.exports